import { override } from "flarum/common/extend";
import listItems from "flarum/common/helpers/listItems";
// import humanTime from "flarum/utils/humanTime";
import IndexPage from "flarum/components/IndexPage";
import TagsPage from "flarum/tags/components/TagsPage";
import sortTags from "flarum/tags/common/utils/sortTags";
import tagIcon from "flarum/tags/common/helpers/tagIcon";
// import CustomTagsChildsModal from "../components/CustomTagsChildsModal";
import LoadingIndicator from "flarum/components/LoadingIndicator";
import Link from "flarum/components/Link";
import Button from "flarum/common/components/Button"
// import tagLabel from "../../common/helpers/tagLabel";
import LogInModal from "flarum/components/LogInModal";

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export default function () {
  TagsPage.prototype.saveSubscription = function (tag, subscription) {
    // console.log(this, tag, subscription);
    this.loading = true;

    if (app.session.user) {
      app
        .request({
          url: `${app.forum.attribute("apiUrl")}/tags/${tag.id()}/subscription`,
          method: "POST",
          body: {
            data: {
              subscription,
            },
          },
        })
        .then((res) => app.store.pushPayload(res))
        .then(() => {
          this.loading = false;
          m.redraw();
        });
      } else {
        app.modal.show(LogInModal);
      }

  };

  override(TagsPage.prototype, "oninit", function(vnode) {
    // super.oninit(vnode);

    app.history.push('tags', app.translator.trans('flarum-tags.forum.header.back_to_tags_tooltip'));

    this.tags = [];

    const preloaded = app.preloadedApiDocument();

    if (preloaded) {
      this.tags = sortTags(preloaded.filter((tag) => !tag.isChild()));
      return;
    }

    this.loading = true;

    app.tagList.load([]).then(() => {
      this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild()));

      this.loading = false;

      m.redraw();
    });
  });

  override(TagsPage.prototype, "view", function (vnode) {
    const pinned = this.tags.filter((tag) => tag.position() !== null);
    // const cloud = this.tags.filter((tag) => tag.position() === null);
    // const tagsStats = app.forum.data.attributes.tagsStats;
    // const title = "Популярные области";
    // console.log(tagsStats);
    if (this.loading) {
      return <LoadingIndicator />;
    }

    return (
      <div className="TagsPage">
        {IndexPage.prototype.hero()}
        <div className="container">
          <nav className="TagsPage-nav IndexPage-nav sideNav">
            <ul>{listItems(IndexPage.prototype.sidebarItems().toArray())}</ul>
          </nav>

          <div className="TagsPage-content sideNavOffset">
            <h1>
              {app.translator.trans("tolyod-advdiscus.forum.sections.header")}
            </h1>
            <ul className="TagTiles">
              {pinned.map((tag) => {
                const curSubscription = tag.subscription() || false;
                const isFollowing = tag.subscription() === "follow";
                const tagText = isFollowing ? "Вы подписаны" : "Подписаться";
                const iconColorClass = isFollowing
                  ? " tagIconSubscribed"
                  : " tagIconNotSubscribed";
                const nextSubscription = [
                  "follow",
                  "lurk",
                  "ignore",
                  "hide",
                ].includes(curSubscription)
                  ? false
                  : "follow";

                return (
                  <li
                    className={"TagTile " + (tag.color() ? "colored" : "")}
                    style={{ backgroundColor: tag.color() }}
                  >
                    <Link className="TagTile-info" href={app.route.tag(tag)}>
                      {tag.icon() && tagIcon(tag, {}, { useColor: false })}
                      <h3 className="TagTile-name">{tag.name()}</h3>
                      <p className="TagTile-description">{tag.description()}</p>
                    </Link>
                  {app.session.user ?
                      <span className={`TagActions tagAction--${nextSubscription}`} style={`--tag-color: ${tag.color()}; --shadow-color: ${tag.color() === "#000000" ? "#fff" : "#040404"} `}>
                        <Button
                          onclick={this.saveSubscription.bind(
                          this,
                          tag,
                          nextSubscription
                        )}
                      >
                          <span className="TagLabel-text">
                            <i className={"icon fas fa-star" + iconColorClass}></i>
                            {tagText}
                          </span>
                        </Button>
                      </span>
                      : "" }
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  });
}
